import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  input,
  booleanAttribute,
  effect,
  inject
} from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatProgressBar } from '@angular/material/progress-bar';
import { ZefFadeAnimationModule } from 'libs/core/src/animations';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'zef-button-progress',
  templateUrl: './button-progress.component.html',
  styleUrls: [ './button-progress.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatProgressBar,
    ZefFadeAnimationModule
  ]
})
export class ButtonProgressComponent {

  #cdRef = inject(ChangeDetectorRef);

  active = input(false, { transform: booleanAttribute })
  buttonRef = input<MatButton>();

  /**
   * The button's own disabled state captured when the progress started,
   * so it can be restored afterwards instead of being forced to `false`.
   */
  #disabledBeforeActive: boolean | undefined;

  constructor() {
    effect(() => {
      const isActive = this.active();
      const button = this.buttonRef();
      if (button) {
        setTimeout(() => {
          if (isActive) {
            this.#disabledBeforeActive ??= button.disabled;
            button.disabled = true;
          } else if (this.#disabledBeforeActive !== undefined) {
            button.disabled = this.#disabledBeforeActive;
            this.#disabledBeforeActive = undefined;
          }
          this.#cdRef.markForCheck();
        })
      }
    })
  }

}
